// Archivo de carga ACH de InterBanking (Interbanco): 8 columnas, sin encabezado, sin tildes,
// máximo 9 registros por archivo. Lo usan la bandeja de Retiros y la bandeja Express.

// Códigos de banco ACH (GuateACH, quetzales). Clave = nombre del banco normalizado (solo A-Z0-9).
export const BANCO_ACH: Record<string, string> = {
  INDUSTRIAL: '115', BANRURAL: '116', BAC: '142', PROMERICA: '140',
  BAM: '144', AGROMERCANTIL: '144', GYT: '145', GYTCONTINENTAL: '145', GTCONTINENTAL: '145',
  CHN: '104', BANTRAB: '112', BANGUAT: '101', AZTECA: '147',
  BANCOR: '128', REFORMADOR: '128', CITIGUATEMALA: '143', CITINA: '130',
  DECREDITO: '146', FOCCIDENTE: '159', FICOHSA: '139', INMOBILIARIO: '113',
}
const normBanco = (b: string) => (b ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '')
export const achCodeFor = (banco: string): string | null => BANCO_ACH[normBanco(banco)] ?? null

// Nombre sin tildes/ñ/comas ni caracteres especiales (requisito del archivo ACH).
const stripName = (s: string) =>
  (s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^A-Za-z .]/g, ' ').replace(/\s+/g, ' ').trim().toUpperCase()
// Split heurístico: últimos 2 tokens = apellidos, el resto = nombres.
const splitNombre = (full: string): [string, string] => {
  const p = stripName(full).split(' ').filter(Boolean)
  if (p.length <= 1) return [p.join(' '), '']
  return [p.slice(0, -2).join(' '), p.slice(-2).join(' ')]
}

export type FilaAch = {
  asociado_nombre: string
  asociado_neo: string
  banco: string
  tipo_cuenta: string
  numero_cuenta: string
  monto: number // lo que se transfiere
}

export function lineasAch(filas: FilaAch[]): { lineas: string[]; sinCodigo: string[] } {
  const sinCodigo: string[] = []
  const lineas: string[] = []
  for (const r of filas) {
    const code = achCodeFor(r.banco)
    if (!code) { sinCodigo.push(`• ${r.asociado_nombre} — ${r.banco} (${r.numero_cuenta})`); continue }
    const prod = (r.tipo_cuenta ?? '').toUpperCase() === 'AHORROS' ? '1' : '0'
    const [nom, ape] = splitNombre(r.asociado_nombre)
    // Concepto = solo el NeoID (dígitos): cada débito del estado de cuenta se cruza con su asociado.
    const concepto = (r.asociado_neo ?? '').replace(/\D/g, '') || 'Retiro Neocoop'
    lineas.push([code, prod, '0', nom, ape, r.numero_cuenta, concepto, r.monto.toFixed(2)].join(','))
  }
  return { lineas, sinCodigo }
}

// Baja uno o varios CSV (grupos de 9). Devuelve cuántos archivos bajó.
export function bajarCsvAch(lineas: string[], prefijo: string): number {
  const MAX = 9
  const grupos: string[][] = []
  for (let i = 0; i < lineas.length; i += MAX) grupos.push(lineas.slice(i, i + MAX))
  const bajar = (contenido: string[], nombre: string) => {
    const blob = new Blob([contenido.join('\r\n') + '\r\n'], { type: 'text/csv;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url; a.download = nombre
    document.body.appendChild(a); a.click(); document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }
  if (grupos.length === 1) bajar(grupos[0], `${prefijo}.csv`)
  else grupos.forEach((g, i) => setTimeout(() => bajar(g, `${prefijo}_parte${i + 1}de${grupos.length}.csv`), i * 400))
  return grupos.length
}
